<script>
	import Logo from "./visuals/NarrowLogo.svelte";
	import TopBarHeader from "./top-bar/TopBarHeader.svelte";
	import Review from "./reviews/Review.svelte";
	import TopBar from "./top-bar/TopBar.svelte";
	import Separator from "./generics/Separator.svelte";
</script>

<TopBar>
	<Logo />
	<TopBarHeader />
</TopBar>
<main>
	<Separator>new reviews</Separator>
	<Review />
	<Review />
	<Separator>read</Separator>
	<Review read={true} />
	<Separator>no more reviews</Separator>
</main>

<style>
	main {
		display: flex;
		flex-direction: column;
		align-items: stretch;
	}
</style>
